<template>
  <div class="theme-wrap" v-if="showTheme">
    <div class="window">
        <!-- <el-radio v-model="radio" label="light">浅色主题</el-radio> -->
      <!-- <div class="title">主题切换</div>
      <div class="window-content">
        <el-radio v-model="radio" label="defalt">默认主题</el-radio>
        <el-radio v-model="radio" label="dark">深色主题</el-radio>
      </div> -->
      <div class="title">菜单方向</div>
      <div class="window-content">
        <el-radio v-model="mode" label="vertical">竖向</el-radio>
        <el-radio v-model="mode" label="horizontal">横向</el-radio>
      </div>
      <div class="window-foot">
        <el-button @click="bindImportScss">确认</el-button>
        <el-button @click="showTheme = false">取消</el-button>
      </div>
    </div>
  </div>
</template>

<script>
import cookie from "@/utils/cookie";
export default {
  data() {
    return {
      showTheme: false,
      radio: "defalt",
      mode: "",
    };
  },
  created() {
    let theme = cookie.getCookie("theme");
    this.radio = theme.substring(6, theme.length);
    console.log(this.radio);
    let mode = cookie.getCookie("mode");
    this.mode = mode;
  },
  methods: {
    bindImportScss() {
      // if ("theme-" + this.radio !== cookie.getCookie("theme")) {
      //   document
      //     .querySelector("body")
      //     .setAttribute("class", "theme-" + this.radio);

      //   this.$store.commit("data/SET_THEME_DATA", "theme-" + this.radio);

      //   cookie.setCookie("theme", "theme-" + this.radio);
      //   location.reload();
      // }

      if (this.mode !== cookie.getCookie("mode")) {
        this.$eventBus.$emit("changeMode", this.mode);
        cookie.setCookie("mode", this.mode);
      }
      this.showTheme = false;
    },
    bindShowTheme() {
      this.showTheme = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.theme-wrap {
  position: fixed;
  top: 0px;
  left: 0px;
  right: 0px;
  bottom: 0px;
  background: rgba(0, 0, 0, 0.5);
  z-index: 999;
  display: flex;
  align-items: center;
  .window {
    width: 350px;
    background: #fff;
    margin: 0px auto;
    .title {
      background: #000;
      height: 30px;
      line-height: 30px;
      text-align: left;
      padding: 0px 10px;
    }
    .window-content {
      width: 100%;
      box-sizing: border-box;
      padding: 10px;
    }
    .window-foot {
      padding: 10px;
    }
  }
}
</style>